var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form__item",
      class: {
        required: _vm.required,
        "default-checkbox": _vm.isCheckbox,
        radiolist: _vm.optionsRadio,
      },
    },
    [
      _vm.label && !_vm.isCheckbox
        ? _c("label", {
            attrs: { for: _vm.uuid },
            domProps: { innerHTML: _vm._s(_vm.label) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "form__description" }, [
            _vm._v(_vm._s(_vm.description)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isCheckbox
        ? [
            _c("label", { staticClass: "form__label--checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value",
                  },
                ],
                ref: "input",
                attrs: { type: "checkbox", required: _vm.required },
                domProps: {
                  checked: Array.isArray(_vm.value)
                    ? _vm._i(_vm.value, null) > -1
                    : _vm.value,
                },
                on: {
                  change: [
                    function ($event) {
                      var $$a = _vm.value,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.value = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.value = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.value = $$c
                      }
                    },
                    _vm.validateField,
                  ],
                  blur: _vm.validateField,
                },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "checkbox__label",
                domProps: { innerHTML: _vm._s(_vm.label) },
              }),
            ]),
          ]
        : _vm.options.length
        ? [
            _vm.optionsRadio
              ? _vm._l(_vm.options, function (option, optionIndex) {
                  return _c(
                    "div",
                    {
                      key: optionIndex,
                      staticClass: "default-radio",
                      class: {
                        "default-radioTs": _vm.brand === _vm.Brand.Travelsphere,
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.value,
                            expression: "value",
                          },
                        ],
                        ref: "input",
                        refInFor: true,
                        attrs: {
                          id: _vm.uuid + optionIndex,
                          type: "radio",
                          required: _vm.required,
                        },
                        domProps: {
                          value: _vm.optionValue(option),
                          checked: _vm._q(_vm.value, _vm.optionValue(option)),
                        },
                        on: {
                          change: [
                            function ($event) {
                              _vm.value = _vm.optionValue(option)
                            },
                            _vm.validateField,
                          ],
                          blur: _vm.validateField,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form__label--radio",
                          attrs: { for: _vm.uuid + optionIndex },
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.optionLabel(option, true)),
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                })
              : _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value,
                        expression: "value",
                      },
                    ],
                    ref: "input",
                    class: { "input-validation-error": _vm.showError },
                    attrs: {
                      id: _vm.uuid,
                      name: _vm.name,
                      disabled: !_vm.enabled,
                      required: _vm.required,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.value = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.validateField,
                      ],
                      blur: _vm.validateField,
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(_vm._s(_vm.placeholder)),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.options, function (option, optionIndex) {
                      return _c(
                        "option",
                        {
                          key: optionIndex,
                          domProps: { value: _vm.optionValue(option) },
                        },
                        [_vm._v(_vm._s(_vm.optionLabel(option)))]
                      )
                    }),
                  ],
                  2
                ),
          ]
        : _c("input", {
            ref: "input",
            class: { "input-validation-error": _vm.showError },
            attrs: {
              name: _vm.name,
              id: _vm.uuid,
              type: _vm.type,
              disabled: !_vm.enabled,
              required: _vm.required,
              placeholder: _vm.placeholder,
              autocomplete: _vm.autocomplete,
              pattern: _vm.validationPattern,
              title: _vm.validationTitle,
              step: _vm.step,
              min: _vm.min,
              max: _vm.max,
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.onInput,
              change: _vm.validateField,
              blur: _vm.validateField,
            },
          }),
      _vm._v(" "),
      _vm.isPassword
        ? _c(
            "div",
            {
              staticClass: "password-toggle",
              on: { click: _vm.togglePasswordVisibility },
            },
            [
              _vm.fieldType === "password"
                ? _c(
                    "svg",
                    {
                      attrs: {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("g", { attrs: { id: "eye" } }, [
                        _c("path", {
                          attrs: {
                            id: "Vector",
                            d: "M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z",
                            stroke: "#757575",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Vector_2",
                            d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                            stroke: "#757575",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]),
                    ]
                  )
                : _c(
                    "svg",
                    {
                      attrs: {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("g", { attrs: { id: "eye-off" } }, [
                        _c("path", {
                          attrs: {
                            id: "Vector",
                            d: "M9.88 9.88C9.58526 10.1547 9.34885 10.4859 9.18488 10.8539C9.02091 11.2218 8.93274 11.6191 8.92564 12.0219C8.91853 12.4247 8.99263 12.8248 9.14351 13.1984C9.2944 13.5719 9.51898 13.9113 9.80385 14.1962C10.0887 14.481 10.4281 14.7056 10.8016 14.8565C11.1752 15.0074 11.5753 15.0815 11.9781 15.0744C12.3809 15.0673 12.7782 14.9791 13.1462 14.8151C13.5142 14.6512 13.8454 14.4148 14.12 14.12",
                            stroke: "#757575",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Vector_2",
                            d: "M10.73 5.08C11.1513 5.02751 11.5754 5.00079 12 5C19 5 22 12 22 12C21.5529 12.9571 20.9922 13.8569 20.33 14.68",
                            stroke: "#757575",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Vector_3",
                            d: "M6.61 6.60999C4.62125 7.96461 3.02987 9.82524 2 12C2 12 5 19 12 19C13.9159 19.0051 15.7908 18.4451 17.39 17.39",
                            stroke: "#757575",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Vector_4",
                            d: "M2 2L22 22",
                            stroke: "#757575",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]),
                    ]
                  ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showError
        ? _c("span", { staticClass: "field-error" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }